export const statusList = [
  {
    value: 'ACTIVE',
    color: 'green',
    text: 'Прошел проверку',
  },
  {
    value: 'FAIL',
    color: 'red',
    text: 'Отказано',
  },
  {
    value: 'CHECK',
    color: 'blue',
    text: 'На проверке',
  },
  {
    value: 'RECHECK',
    color: 'orange',
    text: 'Требует уточнения',
  },
];
